import { render, staticRenderFns } from "./JdiHeading.vue?vue&type=template&id=4525fd2b&"
import script from "./JdiHeading.vue?vue&type=script&lang=ts&"
export * from "./JdiHeading.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports